import * as BABYLON from 'babylonjs';
class PanoDome extends BABYLON.PhotoDome {
    public static readonly DomeRadius = 500;

    private static _options = {
        resolution: 32,
        size: PanoDome.DomeRadius * 2,
        useDirectMapping: false
    }

    constructor(url: string | HTMLImageElement, scene: BABYLON.Scene) {
        super('PanoDome', url as any, PanoDome._options, scene);
    }

    public changeTexture(image: HTMLImageElement) {
        this.texture.dispose();

        const photoTexture = this._initTexture(image, this._scene, PanoDome._options);
        photoTexture.anisotropicFilteringLevel = 1;

        this.photoTexture = photoTexture;
    }

    protected _initTexture(urlsOrElement: string | HTMLElement, scene: BABYLON.Scene, options: any): BABYLON.Texture {
        if (urlsOrElement instanceof HTMLImageElement) {
            return new BABYLON.Texture(
                `data:dome_texture`, // url: string | undefined
                scene, // scene: Nullable<Scene>
                !options.generateMipMaps, // noMipmap?: boolean
                !this._useDirectMapping, // invertY?: boolean
                undefined, // samplingMode?: number
                undefined, // onLoad?: Nullable<() => void>
                undefined, // onError?: Nullable<(message?: string, exception?: any) => void>
                urlsOrElement, // buffer?: string | HTMLImageElement | Blob | ArrayBufferView | ArrayBuffer | HTMLCanvasElement | HTMLVideoElement | OffscreenCanvas | ICanvas
                true, // deleteBuffer?: boolean
                undefined, // format?: number
                undefined, // mimeType?: string
                undefined, // loaderOptions?: any
                undefined, // creationFlags?: number
                undefined, // forcedExtension?: string
            );
        }
        else {
            return super._initTexture(urlsOrElement as string, scene, options);
        }
    }
}

export default PanoDome;